import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchEnrollments(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/enrollments', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchEnrollment(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/enrollments/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createEnrollment(ctx, queryParams){
            return new Promise((resolve, reject) => {
                axios
                    .get('/enrollments/create', {params: queryParams } )
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addEnrollment(ctx, enrollmentData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/enrollments', enrollmentData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteEnrollment(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/enrollments/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        editEnrollment(ctx, { id }){
            return new Promise((resolve, reject) => {
                axios
                    .get(`/enrollments/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateEnrollment(ctx, enrollment) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/enrollments/${enrollment.id}`, enrollment)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },
        alumnos(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/customer')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        cursos(ctx) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/classes')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }

    }
}